exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#table-search-field[data-v-2d91fae4]{margin-right:1rem}", ""]);

